import { useGeneratedThumbnail } from 'common/pdf-viewer/hooks';
import React, { FC, useCallback } from 'react';
import { DownloadIcon, PreviewIcon } from 'common/icons';
import clsx from 'classnames';
import ReactTooltip from 'react-tooltip';
import { downloadFile } from 'global/utils/file';
import { RiDeleteBinLine } from 'react-icons/ri';
import { ThumbnailLoadingIndicator } from './thumbnail-loading-indicator';
import { ThumbnailItemProps } from './thumbnail-item.types';

import styles from './thumbnail-item.module.scss';

export const ThumbnailItem: FC<ThumbnailItemProps> = ({ element, isSelected, onDelete, onSelected }) => {
  const { error, loading, value } = useGeneratedThumbnail(element);

  const hideToolTip = () => {
    setTimeout(() => {
      ReactTooltip.hide();
    }, 0);
  };
  const open = useCallback(() => {
    hideToolTip();
    window.open(element.url, '_blank');
  }, [element.url]);

  const download = useCallback(() => {
    hideToolTip();
    downloadFile(element.downloadUrl, element.fileName);
  }, [element.downloadUrl, element.fileName]);

  const deleteItem = useCallback(
    event => {
      event.stopPropagation();
      hideToolTip();
      onDelete?.(element);
    },
    [element],
  );

  if (loading) {
    return <ThumbnailLoadingIndicator />;
  }

  return (
    <>
      <ReactTooltip
        backgroundColor="white"
        border
        borderColor="var(--primary)"
        effect="solid"
        id="openTooltip"
        textColor="var(--primary)"
        type="info">
        Abrir
      </ReactTooltip>

      <ReactTooltip
        backgroundColor="white"
        border
        borderColor="var(--primary)"
        effect="solid"
        id="downloadItemTooltip"
        textColor="var(--primary)"
        type="info">
        Descargar
      </ReactTooltip>

      <ReactTooltip
        backgroundColor="white"
        border
        borderColor="var(--primary)"
        effect="solid"
        id="deleteItemTooltip"
        textColor="var(--primary)"
        type="info">
        Eliminar
      </ReactTooltip>

      <div
        className={clsx(styles.container, { [styles.isSelected]: isSelected })}
        tabIndex={0}
        onClick={() => onSelected?.(element)}>
        <div className={styles.image}>
          {error ? (
            <span className="text-red-600 text-center pb-10" style={{ fontSize: '13px' }}>
              Error cargando el documento.
            </span>
          ) : (
            <img alt="thumbnail-item" src={value} />
          )}
        </div>
        <div className={styles.info}>
          <h3>{element.name}</h3>
          <p>Adjuntado: {element.createAt}</p>
          <div className="flex w-full gap-2 justify-end items-end">
            {element.canDelete && (
              <RiDeleteBinLine
                className="outline-none cursor-pointer"
                color="#7f7f7f"
                data-for="deleteItemTooltip"
                data-tip
                size="16px"
                viewBox="0 0 22 22"
                onClick={deleteItem}
              />
            )}

            <PreviewIcon
              className="outline-none cursor-pointer"
              data-for="openTooltip"
              data-tip
              size={16}
              onClick={open}
            />

            <DownloadIcon
              className="outline-none cursor-pointer"
              data-for="downloadItemTooltip"
              data-tip
              onClick={download}
            />
          </div>
        </div>
      </div>
    </>
  );
};
